import type { CalculatedInvoice } from "$routes/_lib/billing-v2/invoice-source";
import { PayerType } from "elephant-web/gql";

export type InvoiceMoneyStatus = "paid" | "partial" | "unpaid";

export type FormatInvoiceMoney = (amountInMajorUnits: number) => string;

export const isZeroMoney = (amount: number): boolean => amount === 0;

const patientPayer = (invoice: CalculatedInvoice) =>
  invoice.payers.find((payer) => payer.type === PayerType.Patient);

export const invoiceTotal = (invoice: CalculatedInvoice): number =>
  invoice.balance.total;

export const coveredByPayer = (
  invoice: CalculatedInvoice,
  payerId: string,
): number =>
  invoice.payers.find(
    (payer) =>
      payer.type === PayerType.Insurer &&
      (payer.id === payerId || payer.name === payerId),
  )?.balance.total ?? 0;

export const covered = (invoice: CalculatedInvoice): number =>
  invoice.payers
    .filter((payer) => payer.type === PayerType.Insurer)
    .reduce((total, payer) => total + payer.balance.total, 0);

export const patientBalance = (invoice: CalculatedInvoice): number =>
  patientPayer(invoice)?.balance.total ?? 0;

export const paid = (invoice: CalculatedInvoice): number => {
  const balance = patientPayer(invoice)?.balance;
  return balance ? balance.paid + balance.waived + balance.exempt : 0;
};

export const outstanding = (invoice: CalculatedInvoice): number =>
  patientPayer(invoice)?.balance.due ?? 0;

export const invoiceStatus = (
  invoice: CalculatedInvoice,
): InvoiceMoneyStatus => {
  if (outstanding(invoice) === 0) return "paid";
  return paid(invoice) > 0 ? "partial" : "unpaid";
};
